export default __webpack_public_path__ + "static/media/hoax-left.9254d3e9.png";